import { createStore, createStateHook, type Action, createActionsHook } from 'react-sweet-state';

type State = {
	isMenuOpen: boolean;
	isCloseMenuDisabled: boolean;
};

const initialState: State = {
	isMenuOpen: false,
	isCloseMenuDisabled: false,
};

const actions = {
	setIsMenuOpen:
		(isMenuOpen: boolean): Action<State> =>
		({ setState }) => {
			setState({ isMenuOpen });
		},
	setIsCloseMenuDisabled:
		(isCloseMenuDisabled: boolean): Action<State> =>
		({ setState }) => {
			setState({ isCloseMenuDisabled });
		},
};

const Store = createStore({
	initialState,
	actions,
	name: 'more-actions-menu-store',
});

export const useMoreActionsMenuState = createStateHook(Store);
export const useMoreActionsMenuActions = createActionsHook(Store);
